/* Space Explorer (sections/ap-space-explorer.liquid).
   Plan (house / apartment / business) -> room -> size tier -> up to 3 quick
   preference questions -> top matching waterless diffusers from the live catalog.
   Preferences re-rank, never filter, so every combination returns matches.
   Never shows square footage: sizes are the site tiers only (owner rule 2026-10-04). */
(function () {
  var root = document.querySelector('[data-apsx]');
  if (!root || root.dataset.apsxBound) return;
  root.dataset.apsxBound = '1';

  // Analytics (snippets/ap-track.liquid). Never throws; no-op if the tracker is absent.
  // `booted` stays false through the initial URL-driven render so only explorer_view fires on load.
  var booted = false, lastStepKey = '', lastTop = [];
  function track(n, p) { try { if (typeof window.apTrack === 'function') window.apTrack(n, p || {}, 'space_explorer'); } catch (e) {} }

  var DATA = JSON.parse(root.querySelector('[data-apsx-data]').textContent);
  var PRODUCTS = DATA.products;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');
  // Reduced motion keeps every step and fade (incl. the matching analysis); CSS drops only movement and loops.
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  // Full-screen app shell (page.ap-space-explorer.liquid): guide header owns Back / Start over.
  var app = document.body.classList.contains('apsx-app');
  // Page the shopper came from (kept across steps and reloads) so Add to cart can return them there.
  var RETURN_KEY = 'apsx-return-url';
  (function rememberEntry() {
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (ref && ref.origin === location.origin && ref.pathname !== location.pathname) sessionStorage.setItem(RETURN_KEY, ref.pathname + ref.search);
    } catch (e) {}
  })();
  function returnUrl() {
    var u = '/';
    try { u = sessionStorage.getItem(RETURN_KEY) || '/'; } catch (e) {}
    var url = new URL(u, location.origin);
    url.searchParams.set('ap_cart_open', '1');   // the store's slide cart opens on load with this flag
    return url.pathname + url.search;
  }
  // Soft step changes: View Transitions where supported, CSS entrance animations otherwise.
  var canVT = typeof document.startViewTransition === 'function';
  var inVT = false;
  function soft(fn) {
    if (!canVT || inVT) return fn();
    inVT = true;
    var t = document.startViewTransition(function () { fn(); });
    t.finished.finally(function () { inVT = false; });
  }

  /* ---------- Config ---------- */
  var PLANS = {
    house: { label: 'House', noun: 'room', img: 'house', whole: true,
      pins: { bedroom: [28.6, 41], bathroom: [50.4, 27.5], office: [65.4, 34], kitchen: [24.6, 60.2], living: [49.3, 76.8], entry: [63.2, 59, 'l'], car: [75.7, 58.3] },
      chips: ['bedroom', 'living', 'kitchen', 'bathroom', 'office', 'entry', 'car'] },
    apartment: { label: 'Apartment', noun: 'room', img: 'apartment',
      pins: { living: [40, 56.3], kitchen: [55, 32], bedroom: [70, 57.6], bathroom: [59.3, 65.3], office: [51.4, 79], entry: [42.9, 75.5, 'l'] },
      chips: ['bedroom', 'living', 'kitchen', 'bathroom', 'office', 'entry', 'car'] },
    business: { label: 'Business', noun: 'space', img: 'commercial', business: true,
      pins: { lobby: [24.3, 55], retail: [37.9, 42.3], meeting: [52.9, 34.6, 'l'], workspace: [52.9, 71.7], restroom: [66.4, 38.4], treatment: [75, 53.8, 'l'] },
      chips: ['lobby', 'retail', 'meeting', 'workspace', 'restroom', 'treatment'] }
  };
  // place: placement preference for the room, earlier = better fit.
  var ROOMS = {
    bedroom:   { label: 'Bedroom', the: 'bedroom', def: 'medium', place: ['direct_wall', 'tabletop', 'freestanding'], hints: { small: 'Guest room or nursery', medium: 'Most bedrooms', large: 'Primary suite or loft' } },
    living:    { short: 'Living', label: 'Living room', the: 'living room', def: 'large', place: ['freestanding', 'tabletop', 'direct_wall'], hints: { small: 'Den or reading nook', medium: 'Closed-off living room', large: 'Open-plan living area' } },
    kitchen:   { label: 'Kitchen', the: 'kitchen', def: 'medium', place: ['direct_wall', 'tabletop', 'freestanding'], hints: { small: 'Galley kitchen', medium: 'Most kitchens', large: 'Kitchen open to the living area' } },
    bathroom:  { short: 'Bath', label: 'Bathroom', the: 'bathroom', def: 'small', place: ['direct_wall', 'tabletop', 'freestanding'], hints: { small: 'Powder room or guest bath', medium: 'Primary bathroom', large: 'Spa-size suite' } },
    office:    { short: 'Office', label: 'Home office', the: 'office', def: 'medium', place: ['tabletop', 'direct_wall', 'freestanding'], hints: { small: 'Desk nook', medium: 'Most home offices', large: 'Studio or library' } },
    entry:     { label: 'Entry', the: 'entry', def: 'small', place: ['direct_wall', 'tabletop', 'freestanding'], hints: { small: 'Entry or hallway', medium: 'Foyer', large: 'Grand foyer with open stairs' } },
    car:       { label: 'Car', the: 'car', tiers: ['vehicle', 'small_room'], place: ['vehicle_vent', 'tabletop', 'freestanding', 'direct_wall'] },
    home:      { label: 'Whole home', the: 'whole home', tiers: ['whole_home'], place: ['hvac', 'wall_mount', 'tabletop'] },
    lobby:     { short: 'Lobby', biz: true, subs: { tabletop: 'Reception desk, console or shelf' }, label: 'Reception lobby', the: 'lobby', def: 'large', place: ['freestanding', 'tabletop', 'direct_wall'], hints: { small: 'Small waiting area', medium: 'Reception area', large: 'Open lobby or showroom' } },
    retail:    { short: 'Retail', biz: true, subs: { tabletop: 'Counter, display table or shelf' }, label: 'Retail floor', the: 'store', def: 'large', place: ['freestanding', 'tabletop', 'direct_wall'], hints: { small: 'Kiosk or small shop', medium: 'Boutique', large: 'Large showroom' } },
    meeting:   { short: 'Meeting', biz: true, subs: { tabletop: 'Credenza, shelf or side table' }, label: 'Meeting room', the: 'meeting room', def: 'medium', place: ['tabletop', 'direct_wall', 'freestanding'], hints: { small: 'Huddle room', medium: 'Conference room', large: 'Boardroom' } },
    workspace: { short: 'Office', biz: true, subs: { tabletop: 'Desk, shelf or credenza' }, label: 'Open office', the: 'office', def: 'large', place: ['freestanding', 'tabletop', 'direct_wall'], hints: { small: 'Private office', medium: 'Team room', large: 'Open-plan floor' } },
    restroom:  { short: 'Restroom', biz: true, subs: { tabletop: 'Vanity or shelf' }, label: 'Restroom', the: 'restroom', def: 'small', place: ['direct_wall', 'tabletop', 'freestanding'], hints: { small: 'Single restroom', medium: 'Multi-stall restroom', large: 'Large restroom' } },
    treatment: { short: 'Spa room', biz: true, subs: { tabletop: 'Side table, shelf or counter' }, label: 'Treatment room', the: 'treatment room', def: 'small', place: ['tabletop', 'direct_wall', 'freestanding'], hints: { small: 'Massage or facial room', medium: 'Salon suite', large: 'Spa lounge' } }
  };
  var SIZES = {
    small:  { label: 'Small room', tiers: ['small_room', 'medium_room'], scale: 0.72 },
    medium: { label: 'Medium room', tiers: ['medium_room'], scale: 0.9 },
    large:  { label: 'Large room', tiers: ['large_space'], scale: 1.12 }
  };
  var TIER_RANK = { vehicle: 0, small_room: 1, medium_room: 2, large_space: 3, whole_home: 4 };
  var TIER_LINE = {
    vehicle: 'Made for car cabins', small_room: 'Sized for small rooms', medium_room: 'Sized for medium rooms',
    large_space: 'Sized for large rooms and open spaces', whole_home: 'Scents your whole home through your air system'
  };
  var PLACE = {
    direct_wall:  { line: 'Plugs straight into an outlet, no surface space needed', label: 'Plugged into a wall outlet', sub: 'Out of the way, no surface space needed', chip: 'Plug-in', icon: 'plug' },
    tabletop:     { line: 'Sits neatly on a shelf, nightstand or counter', label: 'On a table or shelf', sub: 'Nightstand, desk, shelf or counter', subBiz: 'Reception desk, shelf or counter', chip: 'Tabletop', icon: 'table' },
    freestanding: { line: 'Freestanding tower that stands on its own', label: 'A standalone tower', sub: 'A statement piece that stands on its own', chip: 'Tower', icon: 'tower' },
    vehicle_vent: { line: 'Clips onto your car air vent', label: 'Clipped to an air vent', sub: 'Stays put while you drive', chip: 'Vent clip', icon: 'vent' },
    hvac:         { line: 'Connects to your home air system' }
  };
  var has = function (p, pl) { return p.placement.indexOf(pl) > -1; };
  var FLAGS = {
    cordless: { title: 'Will you move it between rooms?', titleMulti: 'Want one you can carry between rooms?', yes: 'Yes, I want to carry it around', yesSub: 'Charge it, then use it anywhere', no: 'No, it stays in one spot', chip: 'Cordless', icon: 'battery', test: function (p) { return p.power === 'rechargeable'; } },
    app:      { title: 'Want to control it from your phone?', titleMulti: 'Want to control them from your phone?', titleBiz: 'Want to schedule and adjust it from your phone?', yes: 'Yes, from my phone', yesSub: 'Adjust it without getting up', yesSubBiz: 'Handy for opening hours', no: 'No, simple buttons are fine', chip: 'App control', icon: 'phone', test: function (p) { return !!p.app; } },
    light:    { title: 'Would a soft glow be nice?', yes: 'Yes, a built-in light', yesSub: 'Doubles as mood lighting', no: 'No, just the scent', chip: 'Built-in light', icon: 'bulb', test: function (p) { return !!p.light; } }
  };
  var SWATCH = { black: '#1d1d1f', white: '#f4f1ea', silver: '#c8cacd', grey: '#8b8e92', gray: '#8b8e92', beige: '#d8c7ab' };
  var I = {
    check: '<path d="M5 12.5l4.2 4.2L19 7"/>',
    go: '<path d="M9 6l6 6-6 6"/>',
    back: '<path d="M15 6l-6 6 6 6"/>',
    plug: '<path d="M9 3v5M15 3v5M7 8h10v4a5 5 0 01-10 0zM12 17v4"/>',
    table: '<path d="M4 10h16M6 10v10M18 10v10M9 10V7a3 3 0 016 0v3"/>',
    tower: '<rect x="8" y="3" width="8" height="18" rx="3"/><path d="M12 7v2"/>',
    vent: '<path d="M3 9h18M3 13h18M3 17h18M7 5l2 4M15 5l2 4"/>',
    battery: '<rect x="3" y="7" width="16" height="10" rx="2"/><path d="M21 11v2M7 10v4M11 10v4"/>',
    phone: '<rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M11 18h2"/>',
    bulb: '<path d="M9 18h6M10 21h4M12 3a6 6 0 00-3.5 10.9c.6.5 1 1.2 1 2V16h5v-.1c0-.8.4-1.5 1-2A6 6 0 0012 3z"/>',
    any: '<circle cx="12" cy="12" r="8"/><path d="M8.5 12h7"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/>',
    drop: '<path d="M12 3c3.5 4.2 6 7.4 6 10.5A6 6 0 016 13.5C6 10.4 8.5 7.2 12 3z"/>',
    x: '<path d="M6 6l12 12M18 6L6 18"/>',
    up: '<path d="M6 15l6-6 6 6"/>',
    home: '<path d="M4 11l8-6.5 8 6.5V20H4z"/>',
    plus: '<path d="M12 5v14M5 12h14"/>'
  };
  var svg = function (k, cls) { return '<svg' + (cls ? ' class="' + cls + '"' : '') + ' viewBox="0 0 24 24" aria-hidden="true">' + I[k] + '</svg>'; };

  /* ---------- State ---------- */
  // Multi-room: state.rooms holds every picked room and state.sizes their sizes; state.room / state.size
  // always mirror the room in focus (size step or results tab), so the single-room code works unchanged.
  // Rooms are multi-select by default (owner 2026-10-05): taps tick rooms, Continue moves on.
  // multi = plan taps tick rooms (always on); sq/sqi = rooms still to size; asked = questions answered.
  var state = { plan: 'house', room: null, size: null, qi: 0, answers: {}, pick: {}, step: 'house',
    multi: true, rooms: [], sizes: {}, ri: 0, sq: [], sqi: 0, asked: false };
  var $ = function (sel) { return root.querySelector(sel); };
  var views = { house: $('[data-apsx-view="house"]'), flow: $('[data-apsx-view="flow"]'), results: $('[data-apsx-view="results"]') };
  var house = $('[data-apsx-house]');
  var panel = $('[data-apsx-panel]');
  var top = $('[data-apsx-top]');
  var rail = $('[data-apsx-rail]');
  var hinted = false;
  var lastList = [];

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function num(s) { return parseFloat(String(s).replace(/[^0-9.]/g, '')) || 0; }
  function pct(a, b) { var x = num(a), y = num(b); return x && y > x ? Math.round((1 - x / y) * 100) : 0; }
  function product(h) { return PRODUCTS.filter(function (x) { return x.handle === h; })[0]; }

  /* ---------- Matching ---------- */
  function tiersFor(roomId, size) { var r = ROOMS[roomId]; return r.tiers || (SIZES[size] || SIZES[r.def]).tiers; }
  // Towers first (owner 2026-10-05): in medium and large rooms everywhere except bathrooms, restrooms and the
  // car, freestanding towers rank first, and medium rooms also get the large-room towers ("extra power").
  var NO_TOWER = { bathroom: 1, restroom: 1, car: 1, home: 1 };
  // Being discontinued: always ranked last and never shown as a top match (owner 2026-10-05).
  var PHASING_OUT = { 'plug-in-waterless-diffuser-black': 1 };
  var phasingOut = function (p) { return !!PHASING_OUT[p.handle]; };
  function towerPush(roomId, size) { return !NO_TOWER[roomId] && (size === 'medium' || size === 'large' || (!size && ROOMS[roomId].def !== 'small')); }
  var isTower = function (p) { return p.placement.indexOf('freestanding') > -1; };
  function candidates(roomId, size) {
    var t = tiersFor(roomId, size);
    return PRODUCTS.filter(function (p) {
      return t.indexOf(p.tier) > -1 || (towerPush(roomId, size) && size === 'medium' && isTower(p) && p.tier === 'large_space');
    });
  }
  function placeScore(p, room, roomId, size) {
    if (roomId && towerPush(roomId, size) && isTower(p)) return -1;
    var best = 9;
    p.placement.forEach(function (pl) { var i = room.place.indexOf(pl); if (i > -1 && i < best) best = i; });
    return best;
  }
  // Questions are built one after another on the diffusers that still match the earlier answers,
  // so nothing contradicts or repeats (e.g. no "move it around?" after "plugged into a wall").
  // A question only appears when it still splits that pool, and only offers answers some
  // diffuser meets. Answers re-rank, never filter, so every path still ends with matches.
  // Car (2 diffusers) and whole home (1) skip questions; business skips cordless and light.
  function questionsFor(roomId, size, answers) {
    answers = answers || {};
    var room = ROOMS[roomId], qs = [];
    if (room.tiers) return qs;
    var pool = candidates(roomId, size);
    var order = room.biz ? ['place', 'app'] : ['place', 'cordless', 'app', 'light'];
    order.forEach(function (id) {
      if (qs.length === 3 || pool.length < 2) return;
      var q = null;
      if (id === 'place') {
        var places = ['direct_wall', 'tabletop', 'freestanding'].filter(function (pl) { return pool.some(function (p) { return has(p, pl); }); });
        if (places.length > 1) {
          places.sort(function (a, b) { return room.place.indexOf(a) - room.place.indexOf(b); });
          if (towerPush(roomId, size) && places.indexOf('freestanding') > 0) { places.splice(places.indexOf('freestanding'), 1); places.unshift('freestanding'); }
          q = { id: 'place', title: 'Where would you like it to sit?', none: 'Not sure yet, show me the best fits',
            options: places.map(function (pl) { return { v: pl, label: PLACE[pl].label, sub: (room.subs && room.subs[pl]) || (room.biz && PLACE[pl].subBiz) || PLACE[pl].sub, icon: PLACE[pl].icon }; }) };
        }
      } else {
        var f = FLAGS[id], hits = pool.filter(f.test).length;
        if (hits > 0 && hits < pool.length) {
          q = { id: id, title: (room.biz && f.titleBiz) || f.title, none: f.no,
            options: [{ v: '1', label: f.yes, sub: (room.biz && f.yesSubBiz) || f.yesSub, icon: f.icon }] };
        }
      }
      if (!q) return;
      qs.push(q);
      var ans = answers[id];
      if (ans) {
        var test = id === 'place' ? function (p) { return has(p, ans); } : FLAGS[id].test;
        var narrowed = pool.filter(test);
        if (narrowed.length) pool = narrowed;
      }
    });
    return qs;
  }
  // Several rooms: the questions are asked once for all of them, built on every room's matches together.
  // Placement is left to each room's own ranking (a plug-in suits a bath, a tower a living room), so only
  // the feature questions (cordless, app, light) are asked, and only when they still split the pool.
  function isMulti() { return state.rooms.length > 1; }
  function questionsForRooms(roomIds, sizes, answers) {
    answers = answers || {};
    var live = roomIds.filter(function (id) { return !ROOMS[id].tiers; });
    if (live.length === 1) return questionsFor(live[0], sizes[live[0]], answers);
    if (!live.length) return [];
    var biz = live.some(function (id) { return ROOMS[id].biz; });
    var pool = [];
    live.forEach(function (id) { candidates(id, sizes[id]).forEach(function (p) { if (pool.indexOf(p) < 0) pool.push(p); }); });
    var qs = [];
    (biz ? ['app'] : ['cordless', 'app', 'light']).forEach(function (id) {
      if (pool.length < 2) return;
      var f = FLAGS[id], hits = pool.filter(f.test).length;
      if (!(hits > 0 && hits < pool.length)) return;
      qs.push({ id: id, title: (biz && f.titleBiz) || f.titleMulti || f.title, none: f.no,
        options: [{ v: '1', label: f.yes, sub: (biz && f.yesSubBiz) || f.yesSub, icon: f.icon }] });
      if (answers[id]) { var n = pool.filter(f.test); if (n.length) pool = n; }
    });
    return qs;
  }
  function qsNow() {
    if (isMulti()) return questionsForRooms(state.rooms, state.sizes, state.answers);
    return state.room ? questionsFor(state.room, state.size, state.answers) : [];
  }
  function focusRoom(i) {
    state.ri = Math.max(0, Math.min(i, state.rooms.length - 1));
    state.room = state.rooms[state.ri] || null;
    state.size = state.room && !ROOMS[state.room].tiers ? (state.sizes[state.room] || null) : null;
  }
  function satisfied(p, answers) {
    var met = [];
    if (answers.place && has(p, answers.place)) met.push(PLACE[answers.place].chip);
    Object.keys(FLAGS).forEach(function (k) { if (answers[k] && FLAGS[k].test(p)) met.push(FLAGS[k].chip); });
    return met;
  }
  function wanted(answers) { return (answers.place ? 1 : 0) + Object.keys(FLAGS).filter(function (k) { return answers[k]; }).length; }
  function rank(roomId, size, answers) {
    var room = ROOMS[roomId], tiers = tiersFor(roomId, size);
    return candidates(roomId, size).map(function (p) { return { p: p, met: satisfied(p, answers) }; }).sort(function (a, b) {
      var out = (phasingOut(a.p) ? 1 : 0) - (phasingOut(b.p) ? 1 : 0);
      if (out) return out;
      var cordA = room.biz && a.p.power === 'rechargeable' ? 1 : 0, cordB = room.biz && b.p.power === 'rechargeable' ? 1 : 0;
      return (b.met.length - a.met.length) || (cordA - cordB) || (placeScore(a.p, room, roomId, size) - placeScore(b.p, room, roomId, size)) ||
        (tiers.indexOf(a.p.tier) - tiers.indexOf(b.p.tier)) || (b.p.reviews - a.p.reviews) || (a.p.price - b.p.price);
    });
  }
  function badges(list) {
    // Value/loved badges only go to cards that match as many answers as the best card.
    var out = ['Top match'], used = {}, best = list.length ? list[0].met.length : 0;
    var ok = function (x) { return x.met.length >= best; };
    var cheapest = -1, loved = -1;
    list.forEach(function (x, i) {
      if (!i || !ok(x)) return;
      if (cheapest < 0 || num(variantOf(x.p).price) < num(variantOf(list[cheapest].p).price)) cheapest = i;
      if (loved < 0 || x.p.reviews > list[loved].p.reviews) loved = i;
    });
    for (var i = 1; i < list.length; i++) {
      if (i === cheapest && num(variantOf(list[i].p).price) < num(variantOf(list[0].p).price) && !used.v) { out.push('Best value'); used.v = 1; }
      else if (i === loved && list[i].p.reviews > list[0].p.reviews && !used.l) { out.push('Most loved'); used.l = 1; }
      else out.push(ok(list[i]) ? 'Great fit' : 'Also consider');
    }
    return out;
  }
  // "Why it fits" repeats the shopper's own answers first and never pitches a feature they declined.
  function whyLines(p, roomId, size, answers) {
    answers = answers || {};
    var lines = [], chosen = size && SIZES[size] ? SIZES[size].tiers[0] : null, room = ROOMS[roomId];
    lines.push(chosen && TIER_RANK[p.tier] > TIER_RANK[chosen] ? 'Extra power for a ' + SIZES[size].label.toLowerCase() : TIER_LINE[p.tier]);
    var pl = answers.place && has(p, answers.place) ? answers.place : p.placement.slice().sort(function (a, b) {
      var ia = room.place.indexOf(a), ib = room.place.indexOf(b); return (ia < 0 ? 9 : ia) - (ib < 0 ? 9 : ib);
    })[0];
    if (p.tier !== 'whole_home' && PLACE[pl]) lines.push(PLACE[pl].line);
    var cord = p.power === 'rechargeable' ? 'Cordless after charging, so it moves room to room' : '';
    var app = p.app ? 'Control it from the ' + p.app + ' app' : '';
    var light = p.light ? 'Built-in light: ' + p.light.split(' · ')[0].replace(/^./, function (c) { return c.toLowerCase(); }) : '';
    // 1) features the shopper asked for, 2) other features they did not decline (cordless is not a business selling point)
    if (answers.cordless && cord) lines.push(cord);
    if (answers.app && app) lines.push(app);
    if (answers.light && light) lines.push(light);
    if (cord && answers.cordless === undefined && !room.biz) lines.push(cord);
    if (app && answers.app === undefined) lines.push(app);
    if (light && answers.light === undefined) lines.push(light);
    if (lines.length < 2) lines.push('Waterless, so there is no water to refill');
    return lines.filter(function (l, i) { return lines.indexOf(l) === i; }).slice(0, 3);
  }
  function variantOf(p) {
    var id = state.pick[p.handle];
    return p.variants.filter(function (x) { return x.id === id; })[0] || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
  }
  // QA hook: lets the test harness walk every combination.
  root.__apsx = { ROOMS: ROOMS, SIZES: SIZES, PLANS: PLANS, questionsFor: questionsFor, questionsForRooms: questionsForRooms, rank: rank, state: state };

  /* ---------- Step bar ---------- */
  function stepsFor() {
    var noun = PLANS[state.plan].noun === 'space' ? 'Space' : 'Room';
    if (isMulti() || state.step === 'house') {
      var s = [noun + 's'];
      if (!isMulti() || state.rooms.some(function (id) { return !ROOMS[id].tiers; })) s.push('Sizes');
      if (qsNow().length || !isMulti()) s.push('Your picks');
      s.push('Matches');
      return s;
    }
    var s = [noun];
    if (!(state.room && ROOMS[state.room].tiers)) s.push('Size');
    if (!state.room || questionsFor(state.room, state.size, state.answers).length) s.push('Your picks');
    s.push('Matches');
    return s;
  }
  function renderSteps() {
    var s = stepsFor();
    var cur = { house: 0, size: 1, q: s.indexOf('Your picks'), matching: s.length - 1, results: s.length - 1 }[state.step];
    var plural = PLANS[state.plan].noun + 's';
    $('[data-apsx-steps]').innerHTML = s.map(function (lab, i) {
      return '<li class="' + (i < cur || state.step === 'results' ? 'is-done' : i === cur ? 'is-now' : '') + '"><i></i><span>' + lab + '</span></li>';
    }).join('');
    var nowTxt = {
      house: 'Tap every ' + PLANS[state.plan].noun + ' you want to scent, then continue',
      size: isMulti() && state.sq.length > 1 ? 'Size ' + (state.sqi + 1) + ' of ' + state.sq.length + ' · pick the closest' : 'Pick the size that feels closest',
      q: isMulti() ? 'Asked once for all your ' + plural : 'One tap per question, or skip',
      matching: 'Finding your matches',
      results: 'Your top matches are ready'
    }[state.step];
    $('[data-apsx-now]').textContent = 'Step ' + (cur + 1) + ' of ' + s.length + ' · ' + nowTxt;
  }

  /* ---------- House / plan ---------- */
  function renderPlan() {
    var plan = PLANS[state.plan];
    var img = house.querySelector('.apsx-house__img');
    var src = DATA.plans[plan.img];
    if (img.dataset.plan !== state.plan) {
      img.dataset.plan = state.plan;
      img.srcset = src[0] + ' 1100w, ' + src[1] + ' 1920w';
      img.src = src[1];
    }
    img.alt = { house: 'A two-story home in warm daylight with every room visible', apartment: 'A city apartment in warm daylight with every room visible', business: 'A boutique business space in warm daylight with every area visible' }[state.plan];
    house.querySelector('[data-apsx-pins]').innerHTML = Object.keys(plan.pins).map(function (id, i) {
      var pin = plan.pins[id];
      var short = ROOMS[id].short || ROOMS[id].label;
      return '<button type="button" class="apsx-pin' + (pin[2] === 'l' ? ' apsx-pin--l' : '') + '" style="--x:' + pin[0] + ';--y:' + pin[1] + ';--d:' + i + '" data-apsx-room="' + id + '" aria-label="' + ROOMS[id].label + '"><b>' + svg('check', 'apsx-pin__check') + '<i class="apsx-wisp"></i><i class="apsx-wisp"></i><i class="apsx-wisp"></i></b><span><i class="apsx-pin__full">' + ROOMS[id].label + '</i><i class="apsx-pin__short">' + short + '</i></span></button>';
    }).join('');
    var first = plan.pins[Object.keys(plan.pins)[0]];
    var hint = house.querySelector('.apsx-hint');
    hint.style.setProperty('--x', first[0]); hint.style.setProperty('--y', first[1]);
    hint.hidden = hinted;
    hint.querySelector('em').textContent = 'Tap each ' + plan.noun;
    // Whole home is first in the carousel and goes straight to its result.
    $('[data-apsx-chips]').innerHTML = (plan.whole ? '<button type="button" class="apsx-chip apsx-chip--whole" data-apsx-room="home">' + svg('home') + 'Whole home' + svg('go', 'apsx-chip__go') + '</button>' : '') +
      plan.chips.map(function (id) { return '<button type="button" class="apsx-chip" data-apsx-room="' + id + '">' + svg('check', 'apsx-chip__check') + ROOMS[id].label + '</button>'; }).join('');
    syncMulti(); lockChips();
    $('[data-apsx-sub]').textContent = 'Tap every ' + plan.noun + ' you\'d like to scent. We\'ll match the right waterless diffuser to each one.';
    root.querySelectorAll('[data-apsx-plan]').forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.apsxPlan === state.plan)); });
    house.classList.remove('is-swap'); void house.offsetWidth; if (!reduced) house.classList.add('is-swap');
  }
  // Plans have different chip counts; reserve the tallest so switching House/Apartment/Business never shifts.
  function lockChips() {
    var chips = $('[data-apsx-chips]'); if (!chips.offsetWidth) return;
    var probe = chips.cloneNode(false);
    probe.removeAttribute('data-apsx-chips');
    probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;min-height:0;width:' + chips.offsetWidth + 'px';
    chips.parentNode.appendChild(probe);
    var max = 0;
    Object.keys(PLANS).forEach(function (k) {
      var pl = PLANS[k];
      probe.innerHTML = (pl.whole ? '<button type="button" class="apsx-chip apsx-chip--whole">' + svg('home') + 'Whole home' + svg('go', 'apsx-chip__go') + '</button>' : '') +
        pl.chips.map(function (id) { return '<button type="button" class="apsx-chip">' + svg('check', 'apsx-chip__check') + ROOMS[id].label + '</button>'; }).join('');
      max = Math.max(max, probe.offsetHeight);
    });
    probe.remove();
    chips.style.minHeight = max + 'px';
  }
  // Room picking: pins and chips are checkboxes; Continue (in the old whole-home slot) moves on.
  function syncMulti() {
    var plan = PLANS[state.plan], on = state.multi, n = state.rooms.length;
    root.classList.toggle('is-multi', on);
    root.querySelectorAll('.apsx-house [data-apsx-room], [data-apsx-chips] [data-apsx-room]:not([data-apsx-room="home"])').forEach(function (b) {
      var picked = on && state.rooms.indexOf(b.dataset.apsxRoom) > -1;
      b.classList.toggle('is-on', picked);
      if (on) b.setAttribute('aria-pressed', String(picked)); else b.removeAttribute('aria-pressed');
    });
    var go = $('[data-apsx-multi-go]');
    go.hidden = !on; go.disabled = !n;
    var noun = plan.noun;
    $('[data-apsx-multi-label]').textContent = n ? 'Continue with ' + n + ' ' + noun + (n > 1 ? 's' : '') : 'Tap the ' + noun + 's you want to scent';
    $('[data-apsx-multi-names]').textContent = n === 1 ? ROOMS[state.rooms[0]].label + ' · tap more to add them'
      : n ? state.rooms.map(function (id) { return ROOMS[id].short || ROOMS[id].label; }).join(' · ') : 'Pick as many as you like';
    lightRooms();
    $('[data-apsx-h1]').innerHTML = 'Which ' + noun + 's should <em>smell like a hotel</em>?';
  }
  function toggleRoom(roomId) {
    if (!ROOMS[roomId] || roomId === 'home') return;
    hinted = true; var h = house.querySelector('.apsx-hint'); if (h) h.hidden = true;
    var i = state.rooms.indexOf(roomId);
    if (i > -1) state.rooms.splice(i, 1); else state.rooms.push(roomId);
    track('explorer_room_toggled', { room: roomId, on: i < 0, count: state.rooms.length });
    syncMulti(); renderSteps();
    var go = $('[data-apsx-multi-go]'); go.classList.remove('is-bump'); void go.offsetWidth; if (!reduced && state.rooms.length) go.classList.add('is-bump');
  }
  // Several rooms: every picked room (plus the one under the pointer) stays lit, the rest of the plan dims.
  // One mask layer per room, intersected, so each room gets its own clear circle.
  // Each hole grows in / shrinks out over ~320ms so ticking a room softly lights it.
  var litHover = null, litScale = {}, litRaf = 0;
  function lightRooms() {
    var ids = state.multi && state.step === 'house' ? state.rooms.slice() : [];
    if (state.multi && litHover && ids.indexOf(litHover) < 0) ids.push(litHover);
    // Nothing picked: fade the dim layer straight out (keep the last mask while it fades), so the plan
    // returns to fully lit instead of darkening while the last circle shrinks.
    if (!ids.length) { cancelAnimationFrame(litRaf); litScale = {}; house.classList.remove('is-lit'); return; }
    ids.forEach(function (id) { if (!(id in litScale)) litScale[id] = reduced ? 1 : 0; });
    var start = performance.now(), from = {};
    Object.keys(litScale).forEach(function (id) { from[id] = litScale[id]; });
    cancelAnimationFrame(litRaf);
    (function frame(now) {
      var k = reduced ? 1 : Math.min(1, (now - start) / 320), e = 1 - Math.pow(1 - k, 3);
      Object.keys(from).forEach(function (id) {
        var to = ids.indexOf(id) > -1 ? 1 : 0;
        litScale[id] = from[id] + (to - from[id]) * e;
        if (k === 1 && to === 0) delete litScale[id];
      });
      drawLit();
      if (k < 1) litRaf = requestAnimationFrame(frame);
    })(start);
  }
  function drawLit() {
    var lit = house.querySelector('.apsx-house__lit'), box = house.getBoundingClientRect();
    var holes = box.width ? Object.keys(litScale).map(function (id) {
      var b = house.querySelector('.apsx-pin[data-apsx-room="' + id + '"] b'); if (!b) return '';
      var r = b.getBoundingClientRect(), x = r.left + r.width / 2 - box.left, y = r.top + r.height / 2 - box.top;
      var w = box.width, sc = litScale[id];
      var inner = Math.round(w * (mobile.matches ? 0.075 : 0.06) * sc), outer = Math.max(inner + 1, Math.round(w * (mobile.matches ? 0.17 : 0.14) * sc));
      return 'radial-gradient(circle at ' + Math.round(x) + 'px ' + Math.round(y) + 'px, transparent 0 ' + inner + 'px, #000 ' + outer + 'px)';
    }).filter(Boolean) : [];
    house.classList.toggle('is-lit', holes.length > 0);
    if (holes.length) lit.style.webkitMaskImage = lit.style.maskImage = holes.join(', ');
  }

  /* ---------- Panels ---------- */
  function setScene(roomId) {
    var s = DATA.scenes[roomId], el = $('[data-apsx-scene]');
    $('[data-apsx-frame-tag]').textContent = ROOMS[roomId].label;
    var fr = root.querySelector('.apsx-frame'); if (fr && state.step !== 'size') fr.dataset.size = state.size || 'medium';
    if (el.dataset.room === roomId) return;
    el.dataset.room = roomId;
    el.srcset = s[0] + ' 900w, ' + s[1] + ' 1600w';
    el.sizes = '(max-width: 749px) 100vw, 50vw';
    el.src = s[1];
  }
  function backBtn() { return '<button type="button" class="apsx-back" data-apsx-back>' + svg('back') + '<span>Back</span></button>'; }
  function optHtml(o, checked, attr) {
    return '<button type="button" class="apsx-opt" role="radio" aria-checked="' + checked + '" ' + attr + ' style="--i:' + (o.i || 0) + '">' +
      '<span class="apsx-opt__icon"' + (o.scale ? ' style="--sc:' + o.scale + '"' : '') + '>' + svg(o.icon) + '</span>' +
      '<span class="apsx-opt__txt"><b>' + esc(o.label) + '</b>' + (o.sub ? '<small>' + o.sub + '</small>' : '') + '</span>' +
      '<span class="apsx-opt__check">' + svg('check') + '</span></button>';
  }
  // Size by picture + plain language (never square footage, owner rule).
  var SIZE_HELP = {
    living: 'Can you see the kitchen from your sofa? Choose Large.',
    kitchen: 'Open to the living area? Choose Large.',
    bedroom: 'Bedroom open to a sitting area or loft? Choose Large.',
    office: 'Office open to another room? Pick the next size up.',
    bathroom: 'Bathroom open to the bedroom? Pick the next size up.',
    entry: 'Entry open to the stairs or living area? Pick the next size up.'
  };
  // Size by slider (starts at Medium). The room's own photo zooms in for Small and pulls back for Large,
  // so the picture never shows a different room. Never square footage (owner rule).
  var SIZE_KEYS = ['small', 'medium', 'large'];
  function renderSize() {
    var r = ROOMS[state.room], k = SIZES[state.size] ? state.size : 'medium';
    var help = SIZE_HELP[state.room] || 'Door usually open to a bigger space? Pick the next size up.';
    panel.innerHTML = '<div class="apsx-panel apsx-sizer">' + backBtn() +
      '<p class="apsx-eyebrow">' + (isMulti() && state.sq.length > 1 ? esc(PLANS[state.plan].noun.replace(/^./, function (c) { return c.toUpperCase(); })) + ' ' + (state.sqi + 1) + ' of ' + state.sq.length + ' · ' : '') + esc(r.label) + '</p>' +
      '<h2 class="apsx-h2" tabindex="-1">How big is your <em>' + esc(r.the) + '</em>?</h2>' +
      '<div class="apsx-slider">' +
        '<p class="apsx-slider__out" aria-live="polite"><b data-apsx-size-label></b><small data-apsx-size-hint></small></p>' +
        '<input class="apsx-slider__range" type="range" min="0" max="2" step="1" data-apsx-range aria-label="Room size">' +
        '<div class="apsx-slider__ticks">' + SIZE_KEYS.map(function (key) {
          return '<button type="button" data-apsx-tick="' + key + '">' + SIZES[key].label.replace(' room', '') + '</button>';
        }).join('') + '</div>' +
      '</div>' +
      '<p class="apsx-helper">' + svg('info') + esc(help) + '</p>' +
      '<button type="button" class="ap-button apsx-btn apsx-btn--go" data-apsx-size-go></button></div>';
    sizeVisual(k);
  }
  function sizeVisual(k) {
    var r = ROOMS[state.room]; state.pendingSize = k;
    var label = SIZES[k].label, range = panel.querySelector('[data-apsx-range]');
    if (!range) return;
    range.value = SIZE_KEYS.indexOf(k);
    range.setAttribute('aria-valuetext', label);
    range.style.setProperty('--fill', (SIZE_KEYS.indexOf(k) * 50) + '%');
    panel.querySelector('[data-apsx-size-label]').textContent = label;
    panel.querySelector('[data-apsx-size-hint]').textContent = r.hints[k];
    panel.querySelectorAll('[data-apsx-tick]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.apsxTick === k)); });
    var nextId = isMulti() && state.sqi < state.sq.length - 1 ? state.sq[state.sqi + 1] : null;
    panel.querySelector('[data-apsx-size-go]').innerHTML = (nextId ? label + ' · next: ' + esc(ROOMS[nextId].label.toLowerCase()) : 'Continue with ' + label.toLowerCase()) + svg('go');
    var frame = root.querySelector('.apsx-frame'); if (frame) frame.dataset.size = k;
    $('[data-apsx-frame-tag]').textContent = r.label + ' · ' + label;
  }
  function renderQuestion() {
    var qs = qsNow(), q = qs[state.qi];
    var cur = state.answers[q.id];
    panel.innerHTML = '<div class="apsx-panel">' + backBtn() +
      '<p class="apsx-eyebrow">Quick question ' + (state.qi + 1) + (isMulti() ? ' · for all your ' + PLANS[state.plan].noun + 's' : ' · one tap, or skip') + '</p>' +
      '<h2 class="apsx-h2" tabindex="-1">' + esc(q.title) + '</h2>' +
      '<div class="apsx-opts" role="radiogroup" aria-label="' + esc(q.title) + '">' +
      q.options.map(function (o, i) { o.i = i; return optHtml(o, cur === o.v || (cur === true && o.v === '1'), 'data-apsx-answer="' + o.v + '"'); }).join('') +
      optHtml({ i: q.options.length, icon: 'any', label: q.none }, cur === false || cur === null, 'data-apsx-answer=""') +
      '</div><button type="button" class="apsx-skip" data-apsx-skip>Skip, show my matches' + svg('go') + '</button></div>';
  }
  // Matching: a short, honest "working" moment. Real numbers only: every diffuser we check, the ones
  // that fit the room(s), then the top matches. Rows tick off one by one around a progress ring.
  var MATCH_MS = 2900;
  function renderMatching() {
    var r = ROOMS[state.room], multi = isMulti(), noun = PLANS[state.plan].noun;
    var pool = [];
    (multi ? state.rooms : [state.room]).forEach(function (id) {
      candidates(id, id === state.room ? state.size : state.sizes[id]).forEach(function (p) { if (pool.indexOf(p) < 0) pool.push(p); });
    });
    var top = multi ? state.rooms.length : Math.min(3, pool.length);
    var met = [];
    if (state.answers.place) met.push(PLACE[state.answers.place].chip);
    Object.keys(FLAGS).forEach(function (k) { if (state.answers[k]) met.push(FLAGS[k].chip); });
    var where = multi ? 'your ' + state.rooms.length + ' ' + noun + 's' : (r.tiers ? 'your ' + r.the : 'a ' + SIZES[state.size].label.toLowerCase().replace(' room', '') + ' ' + r.the);
    var rows = [
      ['Checking ' + PRODUCTS.length + ' waterless diffusers', PRODUCTS.length],
      [pool.length + ' sized right for ' + where, pool.length],
      [met.length ? 'Ranking by your picks: ' + met.join(', ') : 'Ranking by best fit and reviews', null],
      [multi ? 'Top match ready for each ' + noun : 'In stock, today\'s prices', top]
    ];
    var thumbs = (multi ? state.rooms : [state.room]).slice(0, 4).map(function (id, i) {
      return '<img src="' + DATA.scenes[id][0] + '" alt="" width="96" height="96" style="--t:' + i + '">';
    }).join('');
    panel.innerHTML = '<div class="apsx-panel apsx-matching" role="status" aria-live="polite" style="--ms:' + MATCH_MS + 'ms">' +
      '<div class="apsx-scan' + (multi ? ' is-multi' : '') + '" aria-hidden="true">' +
        '<svg class="apsx-scan__ring" viewBox="0 0 120 120"><circle class="apsx-scan__track" cx="60" cy="60" r="54"/><circle class="apsx-scan__bar" cx="60" cy="60" r="54" pathLength="100"/></svg>' +
        '<span class="apsx-scan__thumbs">' + thumbs + '</span>' +
        '<span class="apsx-scan__sweep"></span>' +
        '<span class="apsx-scan__dots"><i></i><i></i><i></i><i></i><i></i></span>' +
      '</div>' +
      '<div class="apsx-matching__body">' +
        '<p class="apsx-eyebrow">Finding your matches</p>' +
        '<h2 class="apsx-h2">Matching <em>' + (multi ? state.rooms.length + ' ' + noun + 's' : 'your ' + esc(r.the)) + '</em></h2>' +
        '<p class="apsx-count"><b data-apsx-count>' + PRODUCTS.length + '</b><span data-apsx-count-label>diffusers checked</span></p>' +
        '<ul class="apsx-steps2">' + rows.map(function (row, i) {
          return '<li style="--i:' + i + '" data-apsx-row="' + i + '"><span class="apsx-steps2__ico"><i class="apsx-steps2__spin"></i>' + svg('check') + '</span>' + esc(row[0]) + '</li>';
        }).join('') + '</ul>' +
      '</div></div>';
    // Tick the rows and roll the counter: all diffusers -> the ones that fit -> top matches.
    var step = MATCH_MS / (rows.length + 0.6), shown = PRODUCTS.length;
    rows.forEach(function (row, i) {
      setTimeout(function () {
        if (state.step !== 'matching') return;
        var li = panel.querySelector('[data-apsx-row="' + i + '"]'); if (!li) return;
        li.classList.add('is-done');
        var nx = panel.querySelector('[data-apsx-row="' + (i + 1) + '"]'); if (nx) nx.classList.add('is-now');
        if (row[1] != null && row[1] !== shown) {
          rollCount(shown, row[1]); shown = row[1];
          panel.querySelector('[data-apsx-count-label]').textContent = i === 1 ? 'fit ' + (multi ? 'your ' + noun + 's' : 'your ' + r.the) : (multi ? 'top matches, one per ' + noun : 'top matches for you');
        }
      }, Math.round(step * (i + 0.7)));
    });
    var first = panel.querySelector('[data-apsx-row="0"]'); if (first) first.classList.add('is-now');
  }
  function rollCount(from, to) {
    var el = panel.querySelector('[data-apsx-count]'); if (!el) return;
    var t0 = performance.now();
    (function f(now) {
      var k = Math.min(1, (now - t0) / 450), e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(from + (to - from) * e);
      el.classList.toggle('is-roll', k < 1);
      if (k < 1) requestAnimationFrame(f);
    })(t0);
  }

  /* ---------- Results ---------- */
  function priceHtml(v) {
    var off = pct(v.price, v.compare);
    return '<span class="apsx-price">' + esc(v.price) + (v.compare ? '<s>' + esc(v.compare) + '</s>' : '') + (off ? '<em>Save ' + off + '%</em>' : '') + '</span>';
  }
  function starsHtml(p, compact) {
    if (!p.reviews || !p.rating) return '';
    return '<span class="apsx-rating" aria-label="Rated ' + p.rating + ' out of 5 from ' + p.reviews + ' reviews"><span class="apsx-stars" aria-hidden="true">★★★★★<i style="width:' + (p.rating * 20) + '%">★★★★★</i></span>' + (compact ? '(' + p.reviews + ')' : p.reviews + ' reviews') + '</span>';
  }
  function swatchHtml(p, v) {
    if (p.variants.length < 2) return '';
    return '<div class="apsx-swatches" role="group" aria-label="Color"><span class="apsx-swatches__label">Color: <b>' + esc(v.title) + '</b></span>' +
      p.variants.map(function (x) {
        var c = SWATCH[String(x.title).toLowerCase()] || '';
        return '<button type="button" class="apsx-sw" style="' + (c ? '--c:' + c : '') + '" data-apsx-sw="' + p.handle + '" data-vid="' + x.id + '" aria-label="' + esc(x.title) + (x.available ? '' : ' (sold out)') + '" aria-pressed="' + (x.id === v.id) + '"' + (x.available ? '' : ' disabled') + '></button>';
      }).join('') + '</div>';
  }
  // Card chips come straight from the product's feature metafields (custom.diffuser_feature_1-4_title, body as tooltip).
  function specs(p) { return (p.features || []).filter(function (f) { return f && f.t; }); }
  function specsHtml(p) {
    var fs = specs(p); if (!fs.length) return '';
    return '<ul class="apsx-specs">' + fs.map(function (f) { return '<li title="' + esc(f.b) + '">' + esc(f.t) + '</li>'; }).join('') + '</ul>';
  }
  function oilHtml(p) {
    if (p.oilIncluded) return '<p class="apsx-oil is-included">' + svg('check') + 'Fragrance oil included to start</p>';
    return '<p class="apsx-oil">' + svg('drop') + '<span>Needs waterless oil' + (DATA.refillFrom ? ' · refills from ' + esc(DATA.refillFrom) : '') + '</span>' +
      '<a href="#apsx-scents" data-apsx-goto-scents>Pick scents</a></p>';
  }
  function picksHtml(item) {
    var want = wanted(state.answers);
    if (!want) return '';
    var m = item.met.length;
    var label = m === want ? 'Matches all your answers' : m ? 'Matches ' + m + ' of your ' + want + ' answers' : 'Closest fit for your answers';
    return '<div class="apsx-picks"><span>' + label + '</span>' + item.met.map(function (x) { return '<b>' + svg('check') + esc(x) + '</b>'; }).join('') + '</div>';
  }
  function topCardHtml(item, badge, i) {
    var p = item.p, v = variantOf(p);
    return '<article class="apsx-topcard' + (i === 0 ? ' is-first' : '') + '" style="--i:' + i + '" data-i="' + i + '" data-apsx-card="' + p.handle + '" data-badge="' + esc(badge) + '">' +
      '<a class="apsx-topcard__media" href="' + p.url + '" tabindex="-1" aria-hidden="true"><img src="' + v.image + '" alt="" width="640" height="640"' + (i ? ' loading="lazy"' : '') + '></a>' +
      '<div class="apsx-topcard__head"><span class="apsx-badge">' + (i === 0 ? svg('check') : '') + esc(badge) + '</span>' +
      '<h3 class="apsx-name"><a href="' + p.url + '">' + esc(p.name) + '</a></h3>' +
      '<div class="apsx-meta-row">' + priceHtml(v) + starsHtml(p, true) + '</div></div>' +
      '<div class="apsx-topcard__body">' +
      '<ul class="apsx-why">' + whyLines(p, state.room, state.size, state.answers).map(function (l, k) { return '<li style="--k:' + k + '">' + svg('check') + esc(l) + '</li>'; }).join('') + '</ul>' +
      specsHtml(p) + picksHtml(item) + swatchHtml(p, v) + oilHtml(p) +
      '<div class="apsx-ctas"><button type="button" class="ap-button apsx-btn" data-apsx-add="' + p.handle + '" aria-pressed="false">' + addLabel(p.handle) + '</button><a class="apsx-link" href="' + p.url + '">View details</a></div>' +
      '</div></article>';
  }
  function cardHtml(item) {
    var p = item.p, v = variantOf(p);
    return '<article class="apsx-card" data-apsx-card="' + p.handle + '">' +
      '<a class="apsx-card__media" href="' + p.url + '" tabindex="-1" aria-hidden="true"><img src="' + v.image + '" alt="" width="640" height="640" loading="lazy"></a>' +
      '<div class="apsx-card__in"><h4 class="apsx-card__name"><a href="' + p.url + '">' + esc(p.name) + '</a></h4>' +
      '<p class="apsx-card__meta">' + esc(specs(p).map(function (f) { return f.t; }).join(' · ')) + '</p>' + starsHtml(p, true) + swatchHtml(p, v) +
      '<div class="apsx-card__row">' + priceHtml(v) + '<button type="button" class="ap-button apsx-btn" data-apsx-add="' + p.handle + '" aria-pressed="false">' + addLabel(p.handle) + '</button></div>' +
      '</div></article>';
  }
  function renderResults() {
    var r = ROOMS[state.room];
    var list = rank(state.room, state.size, state.answers);
    lastList = list;
    // Top matches never include a diffuser being phased out (it can still appear under "More that fit").
    var keep = list.filter(function (x) { return !phasingOut(x.p); });
    var topList = (keep.length ? keep : list).slice(0, 3), more = list.filter(function (x) { return topList.indexOf(x) < 0; });
    lastTop = topList.map(function (x) { return x.p.handle; });
    var b = badges(topList);
    var hasQs = qsNow().length > 0, multi = isMulti();
    $('[data-apsx-summary]').innerHTML = '<img src="' + DATA.scenes[state.room][0] + '" alt="" width="64" height="44">' +
      '<span class="apsx-summary__txt"><b>' + esc(r.label) + '</b>' + (r.tiers ? '' : '<span class="apsx-summary__size"> · ' + SIZES[state.size].label + '</span>') + '</span>' +
      (r.tiers ? '' : '<span class="apsx-seg" role="radiogroup" aria-label="Room size">' + ['small', 'medium', 'large'].map(function (k) {
        return '<button type="button" role="radio" aria-checked="' + (k === state.size) + '" data-apsx-resize="' + k + '">' + SIZES[k].label.replace(' room', '') + '</button>';
      }).join('') + '</span>') +
      '<span class="apsx-summary__links">' + (hasQs ? '<button type="button" class="apsx-link" data-apsx-redo>Edit</button>' : '') +
      '<button type="button" class="apsx-link" data-apsx-restart>Start over</button></span>';
    renderRoomTabs();
    $('[data-apsx-result-title]').innerHTML = (topList.length > 1 ? 'Top ' + topList.length + ' matches' : 'Your match') + ' for your <em>' + esc(r.the) + '</em>';
    top.innerHTML = topList.map(function (x, i) { return topCardHtml(x, b[i], i); }).join('');
    top.dataset.count = topList.length;
    top.scrollLeft = 0;
    $('[data-apsx-dots]').innerHTML = topList.length > 1 ? topList.map(function (_, i) { return '<i class="' + (i ? '' : 'is-on') + '"></i>'; }).join('') +
      '<span data-apsx-swipe>1 of ' + topList.length + ' · swipe for more</span>' : '';
    $('[data-apsx-more-wrap]').hidden = !more.length;
    $('[data-apsx-more-title]').textContent = 'More that fit your ' + r.the;
    rail.innerHTML = more.map(cardHtml).join('');
    rail.scrollLeft = 0;
    $('[data-apsx-biz-cta]').hidden = !PLANS[state.plan].business;
    updNav();
    refreshAddButtons(); renderTray(false);
  }

  // Several rooms: one tab per room (check mark once that room has a diffuser in the setup) and one
  // button that puts every room's top match into the setup. Same diffuser in two rooms = quantity 2.
  function topFor(roomId) { var l = rank(roomId, roomId === state.room ? state.size : state.sizes[roomId], state.answers); return l[0] && l[0].p; }
  function roomHasPick(roomId) { return state.setup.some(function (x) { return x.rooms && x.rooms.indexOf(roomId) > -1; }); }
  function renderRoomTabs() {
    var el = $('[data-apsx-roomtabs]'), multi = isMulti();
    el.hidden = state.room === 'home';
    if (el.hidden) { el.innerHTML = ''; return; }
    var open = state.rooms.filter(function (id) { return !roomHasPick(id); });
    var cents = open.reduce(function (a, id) { var p = topFor(id); return a + (p ? variantOf(p).cents : 0); }, 0);
    var n = state.rooms.length, done = !open.length;
    el.innerHTML = '<div class="apsx-roomtabs__list" role="tablist" aria-label="Your ' + PLANS[state.plan].noun + 's">' + state.rooms.map(function (id, i) {
      var on = i === state.ri, picked = roomHasPick(id);
      return '<button type="button" role="tab" class="apsx-roomtab' + (picked ? ' is-picked' : '') + '" aria-selected="' + on + '" data-apsx-tab="' + i + '">' +
        '<img src="' + DATA.scenes[id][0] + '" alt="" width="40" height="28">' +
        '<span>' + esc(ROOMS[id].short || ROOMS[id].label) + '</span>' + (picked ? svg('check', 'apsx-roomtab__check') : '') + '</button>';
    }).join('') +
      '<button type="button" class="apsx-roomtab apsx-roomtab--edit" data-apsx-edit-rooms aria-label="Add or remove ' + PLANS[state.plan].noun + 's">' + svg('plus') + '<span>' + (multi ? 'Edit' : 'Add a ' + PLANS[state.plan].noun) + '</span></button></div>' +
      (multi ? 
      '<button type="button" class="ap-button apsx-btn apsx-addall' + (done ? ' is-in' : '') + '" data-apsx-addall aria-pressed="' + done + '"' +
      ' aria-label="' + (done ? 'Every ' + PLANS[state.plan].noun + ' has a diffuser in your setup' : 'Add the top match for all ' + n + ' ' + PLANS[state.plan].noun + 's to your setup') + '">' +
      (done ? svg('check') + '<span>All ' + n + ' added</span>' : '<span class="apsx-addall__long">Add top matches for all ' + n + ' · ' + money(cents) + '</span><span class="apsx-addall__short">Add all ' + n + '</span>') + '</button>' : '');
  }
  function addAllRooms() {
    var added = false;
    state.rooms.forEach(function (id) {
      if (roomHasPick(id)) return;
      var p = topFor(id); if (!p) return;
      addToRoom(p.handle, id); added = true;
    });
    refreshAddButtons(); renderRoomTabs();
    renderTray(added);
    if (added) { trayOpenedOnce = true; openTray(); }
  }
  function setTab(i) {
    soft(function () { focusRoom(i); renderResults(); renderSteps(); syncUrl(false); });
  }

  /* ---------- Flow control ---------- */
  function show(view) {
    Object.keys(views).forEach(function (k) { views[k].hidden = k !== view; });
    var el = views[view];
    el.classList.remove('is-enter'); void el.offsetWidth; if (!inVT) el.classList.add('is-enter');
  }
  function focusHeading(scope) { var h = scope.querySelector('.apsx-h2'); if (h) h.focus({ preventScroll: true }); }
  function scrollTop() {
    if (app) window.scrollTo({ top: 0, behavior: inVT || reduced ? 'auto' : 'smooth' });
    else root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }

  function go(step, opts) {
    opts = opts || {};
    if (!opts.silent && !opts.inner) return soft(function () { opts.inner = true; go(step, opts); });
    state.step = step;
    root.classList.toggle('is-house', step === 'house');
    document.body.classList.toggle('is-step-flow', step === 'size' || step === 'q' || step === 'matching' || step === 'results');
    renderSteps();
    if (step === 'house') { show('house'); renderPlan(); renderTray(false); }
    else if (step === 'size' || step === 'q' || step === 'matching') {
      if (views.flow.hidden) show('flow');
      setScene(state.room);
      views.flow.classList.toggle('is-matching', step === 'matching');
      if (step === 'size') renderSize(); else if (step === 'q') renderQuestion(); else renderMatching();
      if (!inVT && panel.firstChild) panel.firstChild.classList.add('is-enter');
      renderTray(false);
      if (!opts.silent) focusHeading(panel);
    } else if (step === 'results') {
      show('results'); renderResults();
      if (!opts.silent) focusHeading(views.results);
    }
    if (!opts.silent && (app || mobile.matches || step === 'results' || opts.scroll)) scrollTop();
    if (!opts.fromPop) syncUrl(opts.push);
    trackStep(step);
  }
  // One explorer_step per distinct screen (step + room + question/size index); results also send explorer_results_shown.
  function trackStep(step) {
    var qid = step === 'q' && qsNow()[state.qi] ? qsNow()[state.qi].id : '';
    var key = [step, state.room, state.rooms.join(','), qid, state.qi, state.sqi].join('|');
    if (!booted || key === lastStepKey) { lastStepKey = key; return; }
    lastStepKey = key;
    var p = { step: step };
    if (step !== 'house' && state.room) p.room = state.room;
    if (qid) { p.question = qid; p.position = state.qi + 1; }
    if (step === 'size' && isMulti()) p.position = state.sqi + 1;
    track('explorer_step', p);
    if (step === 'results') track('explorer_results_shown', { room: state.room, rooms: state.rooms.join(','), count: lastTop.length, product_handle: lastTop.join(',') });
  }
  function afterSize() {
    state.qi = 0;
    if (qsNow().length) go('q'); else runMatching();
  }
  function nextQuestion() {
    var qs = qsNow();
    if (state.qi < qs.length - 1) { state.qi++; go('q'); } else runMatching();
  }
  // Several rooms: size each new room in turn, ask the questions once, then show tabs per room.
  function startRooms() {
    if (!state.rooms.length) return;
    if (state.rooms.length === 1) return pickRoom(state.rooms[0]);
    // Coming from a single-room result: its setup lines belong to that room.
    var prev = state.room;
    state.setup.forEach(function (x) { if (!x.rooms.length && prev && state.rooms.indexOf(prev) > -1) x.rooms = [prev]; });
    Object.keys(state.sizes).forEach(function (id) { if (state.rooms.indexOf(id) < 0) delete state.sizes[id]; });
    state.sq = state.rooms.filter(function (id) { return !ROOMS[id].tiers && !state.sizes[id]; });
    state.sqi = 0;
    if (state.sq.length) { focusRoom(state.rooms.indexOf(state.sq[0])); go('size', { push: true }); }
    else afterSizes();
  }
  function sizeAt(i) { state.sqi = i; focusRoom(state.rooms.indexOf(state.sq[i])); go('size'); }
  function afterSizes() {
    state.qi = 0;
    if (!state.asked && qsNow().length) { focusRoom(0); go('q', { push: true }); } else runMatching();
  }
  function runMatching() {
    state.asked = true;
    if (isMulti()) focusRoom(state.sq.length ? state.rooms.indexOf(state.sq[0]) : 0);
    go('matching');
    wait(MATCH_MS).then(function () { if (state.step === 'matching') go('results', { push: true }); });
  }
  function pickRoom(roomId) {
    var r = ROOMS[roomId];
    if (!r) return;
    hinted = true;
    state.room = roomId; state.size = null; state.qi = 0; state.answers = {};
    state.rooms = [roomId]; state.sizes = {}; state.sq = []; state.ri = 0; state.asked = false;
    var start = function () { if (r.tiers) afterSize(); else go('size', { push: true }); };
    var pin = PLANS[state.plan].pins[roomId];
    if (!views.house.hidden && pin && !reduced) {
      house.style.setProperty('--zx', pin[0]); house.style.setProperty('--zy', pin[1]);
      house.classList.add('is-zoom');
      setTimeout(function () { house.classList.remove('is-zoom'); start(); }, 480);
    } else start();
  }
  function backMulti() {
    var qs = qsNow(), house = function () { state.multi = true; go('house', { push: true }); };
    if (state.step === 'results' || state.step === 'matching') {
      if (qs.length) { state.qi = qs.length - 1; focusRoom(0); go('q'); }
      else if (state.sq.length) sizeAt(state.sq.length - 1);
      else house();
    } else if (state.step === 'q') {
      if (state.qi > 0) { state.qi--; go('q'); }
      else if (state.sq.length) sizeAt(state.sq.length - 1);
      else house();
    } else if (state.step === 'size' && state.sqi > 0) sizeAt(state.sqi - 1);
    else house();
  }
  function resetAll() {
    state.room = null; state.size = null; state.answers = {}; state.qi = 0;
    state.multi = true; state.rooms = []; state.sizes = {}; state.sq = []; state.sqi = 0; state.ri = 0; state.asked = false;
  }
  function back() {
    if (isMulti()) return backMulti();
    var hasSize = !ROOMS[state.room].tiers;
    if (state.step === 'results') {
      var qs = qsNow();
      if (qs.length) { state.qi = qs.length - 1; go('q'); }
      else if (hasSize) go('size');
      else go('house', { push: true });
    } else if (state.step === 'q') {
      if (state.qi > 0) { state.qi--; go('q'); }
      else if (hasSize) go('size');
      else go('house', { push: true });
    } else go('house', { push: true });
  }

  /* ---------- URL ---------- */
  function syncUrl(push) {
    var u = new URL(location.href);
    ['plan', 'room', 'size', 'place', 'want', 'rooms', 'tab'].forEach(function (k) { u.searchParams.delete(k); });
    if (state.plan !== 'house') u.searchParams.set('plan', state.plan);
    if (isMulti() && state.step !== 'house') {
      // rooms=bedroom.medium,living.large,car (car and whole home have no size)
      u.searchParams.set('rooms', state.rooms.map(function (id) { return id + (state.sizes[id] ? '.' + state.sizes[id] : ''); }).join(','));
      if (state.step === 'results' && state.ri) u.searchParams.set('tab', String(state.ri));
    } else {
      if (state.room && state.step !== 'house') u.searchParams.set('room', state.room);
      if (state.room && state.size && state.step !== 'house') u.searchParams.set('size', state.size);
    }
    if (state.step === 'results') {
      if (state.answers.place) u.searchParams.set('place', state.answers.place);
      var w = Object.keys(FLAGS).filter(function (k) { return state.answers[k]; });
      if (w.length) u.searchParams.set('want', w.join(','));
    }
    history[push ? 'pushState' : 'replaceState']({ apsx: 1 }, '', u);
  }
  function fromUrl(opts) {
    var q = new URLSearchParams(location.search);
    state.plan = PLANS[q.get('plan')] ? q.get('plan') : 'house';
    var multiRooms = [], multiSizes = {};
    (q.get('rooms') || '').split(',').forEach(function (bit) {
      var kv = bit.split('.'), id = kv[0];
      if (!ROOMS[id] || id === 'home' || multiRooms.indexOf(id) > -1) return;
      multiRooms.push(id);
      if (!ROOMS[id].tiers && SIZES[kv[1]]) multiSizes[id] = kv[1];
    });
    if (multiRooms.length > 1) {
      hinted = true;
      state.rooms = multiRooms; state.sizes = multiSizes; state.qi = 0; state.asked = true; state.answers = {};
      (q.get('want') || '').split(',').forEach(function (k) { if (FLAGS[k]) state.answers[k] = true; });
      state.sq = multiRooms.filter(function (id) { return !ROOMS[id].tiers && !multiSizes[id]; }); state.sqi = 0;
      if (state.sq.length) { state.asked = false; focusRoom(multiRooms.indexOf(state.sq[0])); return go('size', opts); }
      focusRoom(Number(q.get('tab')) || 0);
      return go('results', opts);
    }
    var room = q.get('room') || multiRooms[0];
    state.rooms = ROOMS[room] ? [room] : []; state.sizes = {}; state.sq = []; state.ri = 0;
    if (!ROOMS[room]) { state.room = null; return go('house', opts); }
    state.room = room; hinted = true;
    state.size = ROOMS[room].tiers ? null : (SIZES[q.get('size')] ? q.get('size') : null);
    state.answers = {};
    if (PLACE[q.get('place')]) state.answers.place = q.get('place');
    (q.get('want') || '').split(',').forEach(function (k) { if (FLAGS[k]) state.answers[k] = true; });
    if (!ROOMS[room].tiers && !state.size) go('size', opts);
    else go('results', opts);
  }

  /* ---------- Your setup tray ---------- */
  // Diffusers are collected in a bottom tray (with quantities) together with the scents picked in the
  // shared PDP scent widget, then added to the cart in one go. The cart's Waterless Oil Deal applies 3/5/7/9.
  // Picked scents as an overlapping stack of their bottle photos (read from the widget's own cards).
  function scentImg(input) {
    var card = input.closest('label, li, .ap-df__scent, [class*="scent-card"]') || input.parentNode;
    var img = card && card.querySelector('img');
    return img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '';
  }
  function scentStack(scents, max) {
    var imgs = scents.map(scentImg).filter(Boolean), shown = imgs.slice(0, max), more = scents.length - shown.length;
    if (!shown.length) return '<span class="apsx-tray__drop">' + svg('drop') + '</span>';
    return '<span class="apsx-stack" style="--n:' + (shown.length + (more > 0 ? 1 : 0)) + '">' + shown.map(function (src, i) {
      return '<img src="' + esc(src) + '" alt="" width="44" height="44" style="--s:' + i + '">';
    }).join('') + (more > 0 ? '<b style="--s:' + shown.length + '">+' + more + '</b>' : '') + '</span>';
  }
  function picker() { return root.querySelector('[data-apsx-scents] ap-scent-upsell-picker'); }
  function scentInputs() { var pk = picker(); return pk && pk.selectedInputs ? pk.selectedInputs : []; }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format((cents || 0) / 100);
  }
  var tray = $('[data-apsx-tray]'), sheet = $('[data-apsx-tray-sheet]');
  state.setup = []; state.cleaner = false; var trayOpenedOnce = false;
  // Cleaner upsell: same product and pricing as the waterless PDP. The store's automatic "Diffuser Cleaner"
  // discount takes US$5 off when bought with a diffuser; convert it like the PDP does for other currencies.
  var CLEANER = DATA.cleaner;
  // The cleaner discount does not combine with other product discounts, so when the Waterless Oil Deal
  // is unlocked (3+ oils) the cart keeps the oil saving and charges the cleaner at full price.
  function oilDealOn() { var pk = picker(); return !!(pk && pk.discountPercent > 0); }
  function cleanerPrice() {
    if (!CLEANER) return 0;
    if (oilDealOn()) return CLEANER.cents;
    var rate = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate) || 1;
    return Math.max(0, CLEANER.cents - Math.round(CLEANER.saveUsdCents * rate));
  }
  // Each setup line remembers which rooms it was added for (several-rooms mode), so a card shows
  // "In your setup" only on its own room's tab and the same diffuser for two rooms becomes quantity 2.
  function setupItem(handle) { return state.setup.filter(function (x) { return x.handle === handle; })[0]; }
  function inSetup(handle) {
    var it = setupItem(handle);
    return isMulti() ? !!(it && it.rooms.indexOf(state.room) > -1) : !!it;
  }
  function addToRoom(handle, roomId) {
    var p = product(handle), it = setupItem(handle); if (!p) return;
    if (!it) state.setup.push({ handle: handle, vid: variantOf(p).id, qty: 1, rooms: [roomId] });
    else if (it.rooms.indexOf(roomId) < 0) { it.rooms.push(roomId); it.qty = Math.min(20, it.qty + 1); }
  }
  function removeFromRoom(handle, roomId) {
    var it = setupItem(handle); if (!it) return;
    it.rooms = it.rooms.filter(function (r) { return r !== roomId; });
    it.qty -= 1;
    if (it.qty < 1) state.setup = state.setup.filter(function (x) { return x !== it; });
  }
  function addLabel(handle) { return inSetup(handle) ? 'In your setup' : 'Add to setup'; }
  function refreshAddButtons() {
    root.querySelectorAll('[data-apsx-add]').forEach(function (b) {
      var on = inSetup(b.dataset.apsxAdd);
      b.classList.toggle('is-in', on);
      b.innerHTML = on ? svg('check') + 'In your setup' : 'Add to setup';
      b.setAttribute('aria-pressed', String(on));
    });
  }
  function toggleSetup(handle) {
    var p = product(handle); if (!p) return;
    if (isMulti()) { if (inSetup(handle)) removeFromRoom(handle, state.room); else addToRoom(handle, state.room); }
    else if (inSetup(handle)) state.setup = state.setup.filter(function (x) { return x.handle !== handle; });
    else state.setup.push({ handle: handle, vid: variantOf(p).id, qty: 1, rooms: [] });
    if (!state.setup.length) state.cleaner = false;
    refreshAddButtons();
    renderTray(inSetup(handle));
    // First diffuser in: slide the setup card up so the cleaner and scents are one tap away.
    if (inSetup(handle) && !trayOpenedOnce) { trayOpenedOnce = true; openTray(); }
  }
  function setupTotal() {
    var sum = 0;
    state.setup.forEach(function (x) { var p = product(x.handle), v = p.variants.filter(function (y) { return y.id === x.vid; })[0]; sum += (v ? v.cents : 0) * x.qty; });
    if (state.cleaner && state.setup.length) sum += cleanerPrice();
    var pk = picker(); return sum + (pk ? Number(pk.payableSubtotalCents || 0) : 0);
  }
  function renderTray(pulse) {
    var scents = scentInputs(), n = state.setup.length;
    var show = !views.results.hidden && (n || scents.length);
    tray.hidden = !show;
    root.classList.toggle('has-tray', !!show);
    if (!show) { closeTray(); if (!views.results.hidden) renderRoomTabs(); return; }
    var units = state.setup.reduce(function (a, x) { return a + x.qty; }, 0);
    var bits = [];
    if (units) bits.push(units === 1 ? product(state.setup[0].handle).name : units + ' diffusers');
    if (scents.length) bits.push(scents.length + ' scent' + (scents.length > 1 ? 's' : ''));
    if (state.cleaner && n) bits.push('cleaner');
    $('[data-apsx-tray-thumbs]').innerHTML = state.setup.slice(0, 3).map(function (x) {
      var p = product(x.handle), v = p.variants.filter(function (y) { return y.id === x.vid; })[0] || variantOf(p);
      return '<img src="' + v.image + '" alt="" width="40" height="40">';
    }).join('') + (scents.length ? scentStack(scents, state.setup.length ? 2 : 3) : '');
    var addBtn = $('[data-apsx-tray-add]');
    $('[data-apsx-tray-summary]').textContent = bits.join(' + ') || 'Add a diffuser to start';
    $('[data-apsx-tray-total]').textContent = money(setupTotal());
    addBtn.disabled = !n && !scents.length;
    addBtn.textContent = 'Add to cart';
    renderTrayList();
    renderRoomTabs();
    if (pulse && !reduced) { tray.classList.remove('is-pulse'); void tray.offsetWidth; tray.classList.add('is-pulse'); }
  }
  function renderTrayList() {
    var list = $('[data-apsx-tray-list]'), scents = scentInputs(), pk = picker();
    var rows = state.setup.map(function (x) {
      var p = product(x.handle), v = p.variants.filter(function (y) { return y.id === x.vid; })[0] || variantOf(p);
      return '<li class="apsx-tray__row"><img src="' + v.image + '" alt="" width="56" height="56">' +
        '<span class="apsx-tray__name"><b>' + esc(p.name) + '</b><small>' + (p.variants.length > 1 ? esc(v.title) + ' · ' : '') + esc(v.price) + (x.rooms && x.rooms.length ? ' · ' + esc(x.rooms.map(function (r) { return ROOMS[r].short || ROOMS[r].label; }).join(', ')) : '') + '</small></span>' +
        '<span class="apsx-qty"><button type="button" data-apsx-tray-qty="' + x.handle + '" data-d="-1" aria-label="One fewer"' + (x.qty <= 1 ? ' disabled' : '') + '>−</button><b>' + x.qty + '</b>' +
        '<button type="button" data-apsx-tray-qty="' + x.handle + '" data-d="1" aria-label="One more"' + (x.qty >= 20 ? ' disabled' : '') + '>+</button></span>' +
        '<button type="button" class="apsx-tray__rm" data-apsx-tray-rm="' + x.handle + '" aria-label="Remove ' + esc(p.name) + '">' + svg('x') + '</button></li>';
    }).join('');
    var scentRow = scents.length
      ? '<li class="apsx-tray__row apsx-tray__row--scents">' + scentStack(scents, 3) + '<span class="apsx-tray__name"><b>' + scents.length + ' scent' + (scents.length > 1 ? 's' : '') + ' · ' + esc(scents[0].dataset.size || '') + '</b><small>' +
        '<em class="apsx-tray__p">' + money(pk ? pk.payableSubtotalCents : 0) + '</em>' + (pk && pk.discountPercent ? ' · ' + pk.discountPercent + '% off' : '') + ' · ' + scents.map(function (i) { return esc(i.dataset.name); }).join(', ') + '</small></span>' +
        '<a class="apsx-link" href="#apsx-scents" data-apsx-goto-scents>Edit</a></li>'
      : '<li class="apsx-tray__row apsx-tray__row--hint"><span class="apsx-tray__drop">' + svg('drop') + '</span><span class="apsx-tray__name"><b>Add your scents</b><small>Diffusers run on waterless oil · 3 save 5%, 5 save 10%, 7 save 15%</small></span><a class="apsx-link" href="#apsx-scents" data-apsx-goto-scents>Pick scents</a></li>';
    var cleanerRow = CLEANER && state.setup.length
      ? '<li class="apsx-tray__row apsx-tray__row--upsell' + (state.cleaner ? ' is-on' : '') + '"><img src="' + CLEANER.image + '" alt="" width="56" height="56">' +
        '<span class="apsx-tray__name"><b>Diffuser cleaner</b><small><em class="apsx-tray__p">' + money(cleanerPrice()) + (cleanerPrice() < CLEANER.cents ? ' <s>' + money(CLEANER.cents) + '</s>' : '') + '</em> · ' +
        (oilDealOn() ? 'Clears residue · saving does not stack with the oil deal' : 'Clears residue · maintains output') + '</small></span>' +
        '<button type="button" class="apsx-tray__opt" data-apsx-cleaner aria-pressed="' + state.cleaner + '">' + (state.cleaner ? svg('check') + 'Added' : '+ Add') + '</button></li>'
      : '';
    list.innerHTML = '<ul>' + (rows || '<li class="apsx-tray__row apsx-tray__row--hint"><span class="apsx-tray__name"><b>No diffuser yet</b><small>Tap "Add to setup" on a match.</small></span></li>') + cleanerRow + scentRow + '</ul>' +
      '<p class="apsx-tray__note">Oil savings apply in your cart. Free shipping on qualifying orders is shown at checkout.</p>';
  }
  function openTray() { if (sheet.hidden) { sheet.hidden = false; tray.classList.add('is-open'); $('[data-apsx-tray-toggle]').setAttribute('aria-expanded', 'true'); } }
  function closeTray() { if (!sheet.hidden) { sheet.hidden = true; tray.classList.remove('is-open'); $('[data-apsx-tray-toggle]').setAttribute('aria-expanded', 'false'); } }
  function addSetupToCart(btn) {
    var scents = scentInputs().slice();
    var items = state.setup.map(function (x) { return { id: x.vid, quantity: x.qty, properties: { '_source': 'Space Explorer' } }; });
    if (state.cleaner && CLEANER && items.length) items.push({ id: CLEANER.id, quantity: 1, properties: { '_addon': 'Waterless diffuser cleaner' } });
    scents.forEach(function (input) {
      items.push({ id: Number(input.dataset.variantId), quantity: 1, properties: { '_addon': (input.dataset.pack === 'true' ? 'Waterless fragrance pack ' : 'Waterless fragrance oil ') + input.dataset.size } });
    });
    if (!items.length) return;
    var cartProps = {
      product_handle: state.setup.map(function (x) { return x.handle; }).join(','),
      variant_id: state.setup.map(function (x) { return x.vid; }).join(','),
      quantity: state.setup.reduce(function (a, x) { return a + x.qty; }, 0),
      scents: scents.length, cleaner: !!(state.cleaner && state.setup.length), value: setupTotal(), rooms: state.rooms.join(',')
    };
    btn.classList.add('is-loading'); btn.disabled = true;
    fetch(DATA.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        track('explorer_add_to_cart', cartProps);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('ap:cart:add'));
        btn.innerHTML = svg('check') + 'Added';
        // Leave the flow: back to the page they came from, with the store's slide cart open.
        setTimeout(function () { location.href = returnUrl(); }, 350);
      })
      .catch(function () {
        track('explorer_add_to_cart_failed', cartProps);
        btn.classList.remove('is-loading'); btn.disabled = false;
        $('[data-apsx-tray-summary]').textContent = 'Could not add right now. Please try again.';
      });
  }
  root.addEventListener('ap:scent-picker-change', function () {
    renderTray(true);
    if (booted) track('explorer_scents_changed', { count: scentInputs().length });
  });

  function updNav() {
    var max = rail.scrollWidth - rail.clientWidth - 4;
    var nav = root.querySelector('.apsx-more__nav'); if (nav) nav.hidden = max <= 4;
    root.querySelectorAll('[data-apsx-nav]').forEach(function (b) {
      b.disabled = b.dataset.apsxNav === '-1' ? rail.scrollLeft <= 4 : rail.scrollLeft >= max || max <= 4;
    });
  }
  top.addEventListener('scroll', function () {
    var cards = top.children; if (!cards.length) return;
    var idx = Math.round(top.scrollLeft / (cards[0].offsetWidth + 12));
    root.querySelectorAll('[data-apsx-dots] i').forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    var sw = root.querySelector('[data-apsx-swipe]'); if (sw) sw.textContent = (idx + 1) + ' of ' + cards.length + (idx + 1 < cards.length ? ' · swipe for more' : '');
  }, { passive: true });

  /* ---------- Events ---------- */
  // 1-based rank of a result card: top cards 1-3, then "More that fit" continues the count.
  function cardPos(card) {
    if (card.classList.contains('apsx-topcard')) return Number(card.dataset.i) + 1;
    return lastTop.length + Array.prototype.indexOf.call(rail.children, card) + 1;
  }
  function choose(btn, fn) {
    btn.parentNode.querySelectorAll('[role="radio"]').forEach(function (b) { b.setAttribute('aria-checked', String(b === btn)); });
    btn.classList.add('is-picked');
    wait(320).then(fn);
  }
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-apsx-range]')) sizeVisual(SIZE_KEYS[Number(e.target.value)] || 'medium');
  });
  root.addEventListener('click', function (e) {
    var t;
    // Product links on result cards (image, name, "View details"): track, then let the link navigate.
    if ((t = e.target.closest('[data-apsx-card] a[href]:not([data-apsx-goto-scents])'))) {
      var lc = t.closest('[data-apsx-card]'), lTop = lc.classList.contains('apsx-topcard');
      track('explorer_product_click', { product_handle: lc.dataset.apsxCard, position: cardPos(lc), room: state.room, source: lTop ? 'top' : 'more',
        cta: t.classList.contains('apsx-link') ? 'details' : (t.className.indexOf('__media') > -1 ? 'image' : 'name') });
      return;
    }
    if ((t = e.target.closest('[data-apsx-plan]'))) { var pl = t.dataset.apsxPlan; if (state.plan !== pl) track('explorer_plan_selected', { answer: pl }); if (state.plan !== pl) soft(function () { state.plan = pl; state.rooms = []; state.sizes = {}; state.asked = false; renderPlan(); renderSteps(); syncUrl(false); }); return; }
    if ((t = e.target.closest('[data-apsx-multi-go]'))) {
      if (state.rooms.length) track('explorer_rooms_confirmed', { rooms: state.rooms.join(','), count: state.rooms.length });
      return startRooms();
    }
    if ((t = e.target.closest('[data-apsx-room]'))) {
      if (state.step === 'house' && t.dataset.apsxRoom !== 'home') return toggleRoom(t.dataset.apsxRoom);
      if (ROOMS[t.dataset.apsxRoom]) track('explorer_room_selected', { room: t.dataset.apsxRoom });
      return pickRoom(t.dataset.apsxRoom);
    }
    if ((t = e.target.closest('[data-apsx-back]'))) { track('explorer_back', { step: state.step, source: 'inline' }); return back(); }
    if ((t = e.target.closest('[data-apsx-restart]'))) { track('explorer_restart', { step: state.step, source: 'inline' }); resetAll(); return go('house', { push: true, scroll: true }); }
    if ((t = e.target.closest('[data-apsx-edit-rooms]'))) { track('explorer_edit', { cta: 'rooms', step: state.step }); state.multi = true; return go('house', { push: true, scroll: true }); }
    if ((t = e.target.closest('[data-apsx-tab]'))) {
      var ti = Number(t.dataset.apsxTab);
      if (ti !== state.ri) track('explorer_room_tab', { room: state.rooms[ti], position: ti + 1 });
      return setTab(ti);
    }
    if ((t = e.target.closest('[data-apsx-addall]'))) {
      var openRooms = state.rooms.filter(function (id) { return !roomHasPick(id); });
      if (openRooms.length) track('explorer_add_all', { rooms: openRooms.join(','), count: openRooms.length, product_handle: openRooms.map(function (id) { var p = topFor(id); return p ? p.handle : ''; }).join(',') });
      return addAllRooms();
    }
    if ((t = e.target.closest('[data-apsx-redo]'))) { track('explorer_edit', { cta: 'answers', step: state.step }); state.qi = 0; return go('q', { scroll: true }); }
    if ((t = e.target.closest('[data-apsx-tick]'))) return sizeVisual(t.dataset.apsxTick);
    if ((t = e.target.closest('[data-apsx-size-go]'))) {
      state.size = state.pendingSize || 'medium';
      state.sizes[state.room] = state.size;
      track('explorer_size_selected', { room: state.room, answer: state.size });
      if (isMulti()) return state.sqi < state.sq.length - 1 ? sizeAt(state.sqi + 1) : afterSizes();
      state.answers = {}; return afterSize();
    }
    if ((t = e.target.closest('[data-apsx-answer]'))) {
      var qsCur = qsNow(), q = qsCur[state.qi], v = t.dataset.apsxAnswer;
      return choose(t, function () {
        // A changed answer can change which questions follow, so drop the later ones.
        qsCur.slice(state.qi + 1).forEach(function (x) { delete state.answers[x.id]; });
        state.answers[q.id] = q.id === 'place' ? (v || null) : (v === '1');
        track('explorer_answer', { question: q.id, answer: q.id === 'place' ? (v || 'any') : (v === '1' ? 'yes' : 'no'), position: state.qi + 1, room: state.room });
        nextQuestion();
      });
    }
    if ((t = e.target.closest('[data-apsx-skip]'))) { track('explorer_skip', { step: state.step, question: (qsNow()[state.qi] || {}).id || '', position: state.qi + 1 }); return runMatching(); }
    if ((t = e.target.closest('[data-apsx-resize]'))) {
      var rz = t.dataset.apsxResize;
      if (rz !== state.size) track('explorer_resize', { room: state.room, answer: rz });
      return soft(function () { resize(rz); });
    }
    if ((t = e.target.closest('[data-apsx-sw]'))) {
      var sc0 = t.closest('[data-apsx-card]');
      track('explorer_variant_selected', { product_handle: t.dataset.apsxSw, variant_id: Number(t.dataset.vid), position: sc0 ? cardPos(sc0) : 0 });
      return swatch(t);
    }
    if ((t = e.target.closest('[data-apsx-goto-scents]'))) {
      e.preventDefault();
      closeTray();
      var sc = root.querySelector('[data-apsx-scents]');
      if (sc) sc.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    if ((t = e.target.closest('[data-apsx-add]'))) {
      var ah = t.dataset.apsxAdd, ac = t.closest('[data-apsx-card]');
      toggleSetup(ah);
      track('explorer_setup_toggled', { product_handle: ah, on: inSetup(ah), position: ac ? cardPos(ac) : 0, room: state.room, source: ac && ac.classList.contains('apsx-topcard') ? 'top' : 'more' });
      return;
    }
    if ((t = e.target.closest('[data-apsx-tray-toggle]'))) { track('explorer_tray_toggled', { on: !!sheet.hidden }); return sheet.hidden ? openTray() : closeTray(); }
    if ((t = e.target.closest('[data-apsx-tray-add]'))) return addSetupToCart(t);
    if ((t = e.target.closest('[data-apsx-cleaner]'))) { state.cleaner = !state.cleaner; track('explorer_cleaner_toggled', { on: state.cleaner }); renderTray(true); return; }
    if ((t = e.target.closest('[data-apsx-tray-rm]'))) { var hr = t.dataset.apsxTrayRm; track('explorer_setup_removed', { product_handle: hr }); state.setup = state.setup.filter(function (x) { return x.handle !== hr; }); if (!state.setup.length) state.cleaner = false; refreshAddButtons(); renderTray(false); return; }
    if ((t = e.target.closest('[data-apsx-tray-qty]'))) {
      var hq = t.dataset.apsxTrayQty;
      state.setup.forEach(function (x) {
        if (x.handle !== hq) return;
        x.qty = Math.min(20, Math.max(1, x.qty + Number(t.dataset.d)));
        track('explorer_qty_changed', { product_handle: hq, quantity: x.qty });
        if (x.rooms.length > x.qty) x.rooms.length = x.qty;
      });
      refreshAddButtons(); renderTray(false); return;
    }
    if ((t = e.target.closest('[data-apsx-nav]'))) rail.scrollBy({ left: Number(t.dataset.apsxNav) * Math.round(rail.clientWidth * 0.8), behavior: reduced ? 'auto' : 'smooth' });
  });
  function resize(size) {
    state.size = size; state.sizes[state.room] = size;
    var qs = qsNow();
    if (state.answers.place && !qs.some(function (x) { return x.id === 'place' && x.options.some(function (o) { return o.v === state.answers.place; }); })) delete state.answers.place;
    Object.keys(state.answers).forEach(function (k) { if (!qsNow().some(function (x) { return x.id === k; })) delete state.answers[k]; });
    renderResults(); renderSteps(); syncUrl(false);
  }
  function swatch(t) {
    state.pick[t.dataset.apsxSw] = Number(t.dataset.vid);
    state.setup.forEach(function (x) { if (x.handle === t.dataset.apsxSw) x.vid = Number(t.dataset.vid); });
    renderTray(false);
    var card = t.closest('[data-apsx-card]'), p = product(t.dataset.apsxSw), item = lastList.filter(function (x) { return x.p === p; })[0];
    var tmp = document.createElement('div');
    tmp.innerHTML = card.classList.contains('apsx-topcard') ? topCardHtml(item, card.dataset.badge, Number(card.dataset.i)) : cardHtml(item);
    tmp.firstChild.classList.add('is-static');
    card.replaceWith(tmp.firstChild);
    refreshAddButtons();
  }
  rail.addEventListener('scroll', updNav, { passive: true });
  window.addEventListener('resize', updNav);
  window.addEventListener('resize', function () { if (state.step === 'house') { drawLit(); lockChips(); } });

  // Hover/focus spotlight on the plan: the room glows, the rest dims.
  function spot(roomId, on) {
    var pin = PLANS[state.plan].pins[roomId]; if (!pin) return;
    house.style.setProperty('--sx', pin[0]); house.style.setProperty('--sy', pin[1]);
    house.classList.toggle('is-spot', on);
    if (state.multi) { litHover = on ? roomId : null; lightRooms(); }
    root.querySelectorAll('[data-apsx-room="' + roomId + '"]').forEach(function (el) { el.classList.toggle('is-spot', on); });
    if (on) { var s = DATA.scenes[roomId]; if (s) new Image().src = s[mobile.matches ? 0 : 1]; }
  }
  // Hover lighting only for a real mouse or keyboard focus: on touch, a tap fires mouseover/focusin with no
  // matching "out", which left the tapped room lit (and the rest dark) after it was deselected.
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  views.house.addEventListener('mouseover', function (e) { var t = e.target.closest('[data-apsx-room]'); if (t && canHover.matches) spot(t.dataset.apsxRoom, true); });
  views.house.addEventListener('mouseout', function (e) { var t = e.target.closest('[data-apsx-room]'); if (t) spot(t.dataset.apsxRoom, false); });
  views.house.addEventListener('focusin', function (e) { var t = e.target.closest('[data-apsx-room]'); if (t && t.matches(':focus-visible')) spot(t.dataset.apsxRoom, true); });
  views.house.addEventListener('focusout', function (e) { var t = e.target.closest('[data-apsx-room]'); if (t) spot(t.dataset.apsxRoom, false); });

  // Guide header (full-screen shell): Back steps back, leaving the finder from the first screen.
  var hBack = document.querySelector('[data-apsx-header-back]');
  var hRestart = document.querySelector('[data-apsx-header-restart]');
  if (hBack) hBack.addEventListener('click', function () {
    track('explorer_back', { step: state.step, source: 'header' });
    if (state.step !== 'house') return back();
    var ref = document.referrer && document.referrer.indexOf(location.origin) === 0 && document.referrer.indexOf(location.pathname) === -1;
    if (ref) history.back(); else location.href = '/';
  });
  if (hRestart) hRestart.addEventListener('click', function () {
    track('explorer_restart', { step: state.step, source: 'header' });
    resetAll(); state.plan = 'house';
    go('house', { push: true, scroll: true });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeTray(); });
  window.addEventListener('popstate', function () { fromUrl({ fromPop: true, silent: true }); });
  fromUrl({ silent: true });
  // Single load event: where the shopper landed (deep links can open on size or results).
  track('explorer_view', state.step === 'house' ? { step: 'house', answer: state.plan } : { step: state.step, room: state.room, rooms: state.rooms.join(','), count: state.step === 'results' ? lastTop.length : 0, product_handle: state.step === 'results' ? lastTop.join(',') : '' });
  booted = true;
})();
